import { render, staticRenderFns } from "./AbsenceRequestAdding.vue?vue&type=template&id=bf4d270e"
import script from "./AbsenceRequestAdding.vue?vue&type=script&lang=js"
export * from "./AbsenceRequestAdding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports